import React, { Component, Fragment } from 'react'
import Datetime from 'react-datetime';
import moment from 'moment';
import { date_format } from '../../../server/constants';
import NumberBox from '../../Misc/NumericBox';
import {_addNotificationError, getSalesTaxStatus} from '../../../server/util';
export default class cutoffDays extends Component {
    constructor(props){
        super(props)
        this.state={
            cutOffType: this.props.mealObj.cutOffType||false,
            cutOffDateTime: moment(this.props.mealObj.cutOffDateTime||undefined).isValid()?moment(this.props.mealObj.cutOffDateTime):undefined,
            weeklyOrderCutOffDay:this.props.mealObj.weeklyOrderCutOffDay||'',
            weeklyOrderCutOffTime: moment(this.props.mealObj.weeklyOrderCutOffTime||undefined, 'HH:mm').isValid()?moment(this.props.mealObj.weeklyOrderCutOffTime, 'HH:mm'):moment('23:59','HH:mm'),
            allowOrderNDaysTimeBefore: moment(this.props.mealObj.allowOrderNDaysTimeBefore||undefined,'HH:mm').isValid()?moment(this.props.mealObj.allowOrderNDaysTimeBefore ,'HH:mm'):moment('23:59','HH:mm'),
            orderDateExtensionStatus:this.props.mealObj.orderDateExtensionStatus||false,
            allowOrderNDaysBefore: this.props.mealObj.allowOrderNDaysBefore==0?0: this.props.mealObj.allowOrderNDaysBefore||'',
            isSideSelect:this.props.mealObj.isSideSelect||false,
            extraEnableForCaterer:this.props.mealObj.extraEnableForCaterer||false,
            autoReminderDate1:this.props.mealObj.autoReminderDate1?true:false,
            autoReminderDate2:this.props.mealObj.autoReminderDate2?true:false,
            isWeekly:this.props.isWeekly||false,
            salesTaxPerc:this.props.mealObj.salesTaxPerc||0.00,
            isExtraPreOrder:this.props.mealObj.isExtraPreOrder||false
        }
    }
    cutOffChange = (e) => {
        this.setState({cutOffDateTime: new Date(e)})
    };
    componentWillReceiveProps=(nextProps)=>{
        const {mealObj}=nextProps;
        this.setState({
            cutOffType:mealObj.cutOffType,
            cutOffDateTime:moment(mealObj.cutOffDateTime||undefined).isValid()?moment(mealObj.cutOffDateTime||undefined):undefined,
            weeklyOrderCutOffDay:mealObj.weeklyOrderCutOffDay,
            weeklyOrderCutOffTime: moment(mealObj.weeklyOrderCutOffTime||undefined,'HH:mm').isValid()?moment(mealObj.weeklyOrderCutOffTime,'HH:mm'):moment('23:59','HH:mm'),
            allowOrderNDaysTimeBefore: moment(mealObj.allowOrderNDaysTimeBefore||undefined,'HH:mm').isValid()?moment(mealObj.allowOrderNDaysTimeBefore,'HH:mm'):moment('23:59','HH:mm'),
            orderDateExtensionStatus:mealObj.orderDateExtensionStatus,
            allowOrderNDaysBefore:mealObj.allowOrderNDaysBefore,
            isSideSelect:mealObj.isSideSelect||false,
            extraEnableForCaterer:mealObj.extraEnableForCaterer||false,
            autoReminderDate1:mealObj.autoReminderDate1?true:false,
            autoReminderDate2:mealObj.autoReminderDate2?true:false,
            isWeekly:nextProps.isWeekly,
            salesTaxPerc:mealObj.salesTaxPerc||0.00,
            isExtraPreOrder:mealObj.isExtraPreOrder||false
        });
    }
    render() {
        const {cutOffType, cutOffDateTime, weeklyOrderCutOffDay, allowOrderNDaysBefore,
            orderDateExtensionStatus, isSideSelect, extraEnableForCaterer, 
            autoReminderDate1, autoReminderDate2, weeklyOrderCutOffTime, allowOrderNDaysTimeBefore, salesTaxPerc, isExtraPreOrder}= this.state
        return (
            <Fragment>
                <h4>Cut-Off Date</h4>
                <form className="form-horizontal" style={{marginLeft:'10px'}}>
                    <div className="form-group">
                        <div className="row">
                            <div className="col-md-5">
                                <div className="custom-control custom-radio" style={{marginTop:'10px'}}>
                                    <input type="radio" className="custom-control-input"
                                    name="rbCutOffDate" checked={cutOffType=='M'} id="cutoffDate" onChange={(e)=>{
                                        this.setState({
                                            cutOffType:e.target.checked?'M':'W',
                                            weeklyOrderCutOffDay:'',
                                            weeklyOrderCutOffTime:moment('23:59','HH:mm'),
                                            allowOrderNDaysTimeBefore:moment('23:59','HH:mm'),
                                            cutOffDateTime:undefined, 
                                            orderDateExtensionStatus:false,
                                            allowOrderNDaysBefore:''})
                                    }} />
                                    <label className="custom-control-label" htmlFor="cutoffDate" style={{marginLeft:'10px'}}>Date</label>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="uploadFileInfo createmenu-month-group">
                                    <div className="input-group">
                                    <fieldset disabled={cutOffType!=='M'}>
                                        <Datetime id="cutoff" timeFormat="HH:mm:ss"
                                        dateFormat={date_format()}
                                            value={cutOffDateTime}
                                            isValidDate={(currentDate)=>{
                                                 let todayDate=moment();
                                                    todayDate.set({hour:0,minute:0,second:0,millisecond:0})
                                                    currentDate.set({hour:0,minute:0,second:0,millisecond:0})
                                                    return todayDate<=currentDate;
                                                }}
                                             onChange={this.cutOffChange}
                                            locale='en-US'
                                            closeOnSelect 
                                            renderInput={(props, openCalendar, closeCalendar) => {
                                                return (
                                                    <Fragment>
                                                        <input className="form-control" {...props} />
                                                        <button type="button" className="input-group-addon" onClick={openCalendar}>
                                                            <i className="fa fa-calendar"> </i>
                                                        </button>
                                                    </Fragment>
                                                );
                                            }}
                                            />
                                        </fieldset>
                                    </div>
                                </div>
                            </div>
                        </div>   
                    </div>
                        <div className="form-group">
                        <div className="row">
                            <div className="col-md-5">
                                <div className="custom-control custom-radio" style={{marginTop:'7px'}}>
                                    <input type="radio" className="custom-control-input" 
                                    name="rbCutOffDate" checked={cutOffType=='W'} id="wcutoffDate" onChange={(e)=>{                                        
                                        this.setState({
                                            cutOffType:e.target.checked?'W':'M',
                                            weeklyOrderCutOffDay:'',
                                            weeklyOrderCutOffTime:moment('23:59','HH:mm'),
                                            allowOrderNDaysTimeBefore:moment('23:59','HH:mm'),
                                            cutOffDateTime:undefined, orderDateExtensionStatus:false,
                                            allowOrderNDaysBefore:''})
                                    }} />
                                    <label className="custom-control-label" htmlFor="wcutoffDate" style={{marginLeft:'10px'}}>Weekly</label>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <select className="form-control" value={weeklyOrderCutOffDay} disabled={cutOffType!=='W'} onChange={(e)=>{
                                    this.setState({weeklyOrderCutOffDay:e.target.value});
                                }}>
                                    <option value="">Select</option>
                                    <option value="Sun">Sunday</option>
                                    <option value="Mon">Monday</option>
                                    <option value="Tue">Tuesday</option>
                                    <option value="Wed">Wednesday</option>
                                    <option value="Thu">Thursday</option>
                                    <option value="Fri">Friday</option>
                                    <option value="Sat">Saturday</option>
                                </select>
                            </div>
                            <div className="col-md-4">
                            <div className="uploadFileInfo createmenu-month-group">
                                    <div className="input-group">
                                        <fieldset disabled={cutOffType!=='W'}>
                                            <Datetime 
                                                id="weeklyOrderCutOffTime" 
                                                timeFormat={"HH:mm"}
                                                value={weeklyOrderCutOffTime} 
                                                viewMode="time"  
                                                dateFormat={false}                                         
                                                onChange={(e)=>{
                                                    this.setState({weeklyOrderCutOffTime: e});
                                                }}
                                                locale='en-US'
                                                closeOnSelect 
                                                renderInput={(props, openCalendar, closeCalendar) => {
                                                    return (
                                                        <Fragment>
                                                            <input className="form-control" {...props} />
                                                            <button type="button" className="input-group-addon" onClick={openCalendar}>
                                                                <i className="fa fa-calendar"> </i>
                                                            </button>
                                                        </Fragment>
                                                    );
                                                }}
                                            />
                                        </fieldset> 
                                    </div>
                                </div>
                            </div>
                        </div>   
                    </div>
                        <div className="form-group">
                            <div className="row">
                                <div className="col-md-5">
                                    <div className="custom-control custom-radio" style={{marginTop:'7px'}}>
                                        <input type="radio" className="custom-control-input" 
                                        name="rbCutOffDate" checked={cutOffType=='R'} id="rcutoffDay" onChange={(e)=>{                                        
                                            this.setState({
                                                cutOffType:e.target.checked?'R':'W',
                                                weeklyOrderCutOffDay:'',
                                                weeklyOrderCutOffTime:moment('23:59','HH:mm'),
                                                allowOrderNDaysTimeBefore:moment('23:59','HH:mm'),
                                                cutOffDateTime:undefined, 
                                                orderDateExtensionStatus:false,
                                                allowOrderNDaysBefore:''})
                                        }} />
                                        <label className="custom-control-label" htmlFor="rcutoffDay" style={{marginLeft:'10px'}}>Allow no of days before order</label>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <select className="form-control" name="allowOrderNDaysBefore" 
                                    disabled={cutOffType!=='R'} id="allowOrderNDaysBefore" value={allowOrderNDaysBefore} onChange={(e)=>{
                                            this.setState({allowOrderNDaysBefore:e.target.value});
                                        }} >
                                        <option value={''}>Select</option>
                                        <option value={-1}>Same Day</option>
                                        <option value={0}>0</option>
                                        <option value={1}>1</option>
                                        <option value={2}>2</option>
                                        <option value={3}>3</option>
                                        <option value={4}>4</option>
                                        <option value={5}>5</option>
                                        <option value={6}>6</option>
                                        <option value={7}>7</option>
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <div className="uploadFileInfo createmenu-month-group">
                                            <div className="input-group">
                                                <fieldset disabled={cutOffType!=='R'}>
                                                    <Datetime 
                                                        id="allowOrderNDaysTimeBefore" 
                                                        timeFormat={"HH:mm"}
                                                        value={allowOrderNDaysTimeBefore} 
                                                        viewMode="time"  
                                                        dateFormat={false}                                         
                                                        onChange={(e)=>{
                                                            this.setState({allowOrderNDaysTimeBefore: e});
                                                        }}
                                                        locale='en-US'
                                                        closeOnSelect 
                                                        renderInput={(props, openCalendar, closeCalendar) => {
                                                            return (
                                                                <Fragment>
                                                                    <input className="form-control" {...props} />
                                                                    <button type="button" className="input-group-addon" onClick={openCalendar}>
                                                                        <i className="fa fa-calendar"> </i>
                                                                    </button>
                                                                </Fragment>
                                                            );
                                                        }}
                                                    />
                                                </fieldset> 
                                            </div>
                                        </div>
                                </div>
                            </div>   
                        </div>
                        {
                            getSalesTaxStatus()?
                        <div className='form-group'>
                            <div className='row'>
                                <div className='col-md-5'>
                                    <label className='control-label ' htmlFor="salesTaxPerc">Sales tax rate (%)</label>
                                </div>
                                <div className='col-md-2'>
                                    <NumberBox type="text" className="form-control" maxLength="6" 
                                                    value={salesTaxPerc} 
                                                    id="salesTaxPerc" name="salesTaxPerc" placeholder="0.00"  
                                                    style={{textAlign:'right'}} 
                                                    onChange={(e)=>{
                                                        this.setState({salesTaxPerc:e.target.value})
                                                    }} noValidate/>
                                </div>
                            </div>
                        </div> :null
                        }    
                                              
                    <div className="form-group">
                        <div className="checkbox">
                            <label><input type="checkbox" checked={isSideSelect} onChange={(e)=>{
                                this.setState({isSideSelect:e.target.checked})
                            }} />Allow sides selection during pre-order</label>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="checkbox">
                            <label><input type="checkbox" checked={isExtraPreOrder} onChange={(e)=>{
                                this.setState({isExtraPreOrder:e.target.checked})
                            }} />Allow pre-ordering of A la carte items</label>
                        </div>
                    </div>
                   { cutOffType==='M' && <Fragment>
                            <h4 style={{marginBottom: '7px'}}>REMINDER OPTIONS</h4>
                            <div className="checkbox">
                                <label><input type="checkbox" checked={autoReminderDate1} onChange={(e)=>{
                                    this.setState({autoReminderDate1:e.target.checked})
                                }} /> Send a reminder a week before cutoff date </label>
                            </div>
                            <div className="checkbox">
                                <label><input type="checkbox" checked={autoReminderDate2} onChange={(e)=>{
                                    this.setState({autoReminderDate2:e.target.checked})
                                }} /> Send a reminder two days before cutoff date</label>
                            </div>
                        </Fragment>   }                                   
                    <button type="button" onClick={(e)=>{
                        if(cutOffType==='W'){
                            if(weeklyOrderCutOffDay==''){
                                _addNotificationError("Please select weekday",this.props);
                                return false;
                            }
                        }else if(cutOffType==='R'){
                            if(allowOrderNDaysBefore===''){
                                _addNotificationError("Please select no of days",this.props);
                                return false;
                            }
                        }else if(cutOffType==='M'){
                            if((cutOffDateTime||'')===''){
                                _addNotificationError("Please select cut of date and time",this.props);
                                return false;
                            }
                        }
                        this.props.onCutoffDateSubmit(this.state);
                    }}
                    className="btn btn-sm btn-success pull-right">Submit</button>
                </form>        
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Menu/cutoffDays.jsx